import React from 'react';
import { Sparkles, ShieldCheck, Headset, MousePointerClick } from 'lucide-react';
import { useApp } from '../context/AppContext';

const icons = [Sparkles, ShieldCheck, Headset, MousePointerClick];

const Advantages = () => {
  const { t } = useApp();
  const items = t('adv.items');
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-3xl">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[color:var(--brand-dark)]">{t('adv.title')}</h2>
          <p className="mt-4 text-gray-500 leading-relaxed">{t('adv.subtitle')}</p>
        </div>
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
          {(Array.isArray(items) ? items : []).map((it, i) => {
            const Icon = icons[i];
            return (
              <div key={i} className="card-hover bg-[color:var(--brand-muted)] rounded-2xl p-5 sm:p-7">
                <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-5" style={{ backgroundColor: 'var(--brand-dark)' }}>
                  <Icon className="w-7 h-7" style={{ color: 'var(--brand-accent)' }} />
                </div>
                <h3 className="font-bold text-lg text-[color:var(--brand-dark)] mb-2">{it.t}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{it.d}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
